import {
  SecondaryFilter,
  SecondaryFilterOptions
} from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";
import { FilterData, List, ObjFilterList } from "../../model/List";
import {
  DYNAMIC_SELECT_TEXT,
  SELECT_EVENTS
} from "@/shared/constants/SelectConstants";

@Component({
  name: "FilterTypeSelect"
})
export default class FilterTypeSelect extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() filterData!: FilterData[];
  @Prop() isMultipleOption!: boolean;
  @Prop() private selectFilter!: ObjFilterList[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  textNotFound = DYNAMIC_SELECT_TEXT.NOT_FOUND;
  searchInput = "";
  keyWord = "";
  placeholder = "Filtrar " + this.itemFilter.name;
  clearData = 0;
  showActionButton = {} as Record<string, boolean>;

  beforeMount() {
    this.initFilter();
  }

  reload() {
    this.clearData = 1 - this.clearData;
  }

  get optionsLocal(): SecondaryFilterOptions[] | List[] {
    return this.itemFilter.options && this.itemFilter.options.length
      ? this.itemFilter.options
      : this.filterData.find(
          filter => filter.secondaryFilterKey == this.itemFilter.key
        )?.values ?? [];
  }

  get optionsSelect(): ObjFilterList[] {
    return (
      this.optionsLocal
        .filter(listItem => listItem.selected)
        .map(listItem => ({ key: listItem.key!, name: listItem.name })) ?? []
    );
  }

  get options(): SecondaryFilterOptions[] {
    if (this.optionsLocal.length == 0) {
      this.callData();
    }
    return this.optionsLocal.filter(
      listItem =>
        listItem.name
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .indexOf(
            this.searchInput
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          ) > -1
    );
  }

  callData() {
    this.$emit(EVENT_EMITTER.CALL_DATA, this.itemFilter);
  }

  setButtonVisibility(item: SecondaryFilterOptions, isVisible: boolean) {
    this.$set(this.showActionButton, item.name, isVisible);
  }

  editItem(item: SecondaryFilterOptions) {
    this.$emit(EVENT_EMITTER.EDIT_DATA, item);
  }

  removeFilterSelect(filter: string) {
    const filterObj = this.optionsLocal?.find(option => option.name == filter);
    if (!filterObj) {
      return;
    }
    filterObj.selected = false;
    this.changeSelect();
  }

  get selectFilterLocalModel() {
    return this.isMultipleOption || !this.selectFilter
      ? this.selectFilter
      : this.selectFilter[0];
  }

  set selectFilterLocalModel(select: ObjFilterList | ObjFilterList[]) {
    this.selectFilterLocal = Array.isArray(select) ? select : [select];
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  changeOptionSelect(option: SecondaryFilterOptions) {
    if (!this.isMultipleOption) {
      const nuwSelect: ObjFilterList = { name: option.name, key: option.key! };
      this.selectFilterLocal =
        this.optionsSelect.length == 0 ? [] : [nuwSelect];
    } else {
      this.changeSelect();
    }
  }

  changeSelect() {
    this.selectFilterLocal = this.optionsSelect;
  }

  onIntersect(options: IntersectionObserverEntry[]) {
    if (options[0].isIntersecting) {
      this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA);
    }
  }

  searchData() {
    if (this.keyWord && this.keyWord.length >= 2) {
      this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA, this.keyWord);
    }
  }

  @Watch("selectFilter")
  initFilter() {
    (this.optionsLocal as SecondaryFilterOptions[])?.map(selectOption => {
      const newStateSelect =
        (this.selectFilterLocal?.findIndex(
          filter => filter.key == selectOption.key
        ) ?? -1) !== -1;
      Vue.set(selectOption, EVENT_EMITTER.SELECTED, newStateSelect);
      return selectOption;
    });
    this.reload();
  }

  change() {
    if (this.isPrincipal) {
      this.$emit(EVENT_EMITTER.CHANGE);
    }
  }
}
